// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

// slick
import $ from 'jquery';
import 'third/jquery.slick';

export default class ProductListSlider extends WebComponent {
  didMount() {
    const slider = $('.product-list-slider');
    const isGallery = this.element.classList.contains('gallery-slider');
    const isFavouriteAiSlider = this.element.classList.contains('favourite-ai__slider');
    const isTilesHpSlider = this.element.classList.contains('tiles-hp-slider');
    const isTopProductsSlider = this.element.classList.contains('top-products-slider');
    const isPDAuthorsSlider = this.element.classList.contains('pd-authors-slider');
    const topProductsSettings = {
      mobileFirst: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      prevArrow: '<span class="product-list-slider__arrow product-list-slider__arrow--prev"><svg class="svg-icon"><use xlink:href="#slider-prev"></use></svg></span>',
      nextArrow: '<span class="product-list-slider__arrow product-list-slider__arrow--next"><svg class="svg-icon"><use xlink:href="#slider-next"></use></svg></span>',
      infinite: true,
      speed: 500,
      cssEase: 'ease-in-out',
      draggable: true,
      // rows: 0,
      variableWidth: false,
      // centerMode: true,
      responsive: [
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 5,
            dots: false,
          },
        },
      ],
    };

    setTimeout(() => {
      if (isGallery) {
        // page gallery
        $(this.element).slick({
          mobileFirst: true,
          arrows: true,
          dots: false,
          prevArrow: '<span class="gallery-slider__arrow gallery-slider__arrow--prev"><svg class="svg-icon"><use xlink:href="#gallery-prev"></use></svg></span>',
          nextArrow: '<span class="gallery-slider__arrow gallery-slider__arrow--next"><svg class="svg-icon"><use xlink:href="#gallery-next"></use></svg></span>',
          infinite: true,
          speed: 500,
          cssEase: 'ease-in-out',
          draggable: true,
          variableWidth: false,
        });
      } else if (isTopProductsSlider) {
        // HP top products slider
        $(this.element).slick(topProductsSettings);
        } else if (isTilesHpSlider) {
        // HP tiles slider
        $(this.element).slick({
          mobileFirst: true,
          arrows: false,
          dots: true,
          infinite: true,
          speed: 500,
          cssEase: 'ease-in-out',
          draggable: true,
          variableWidth: false,
          responsive: [
            {
              breakpoint: 639,
              settings: 'unslick',
            },
          ],

        });
      } else if (isFavouriteAiSlider) {
        $(this.element).slick({
          mobileFirst: true,
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          prevArrow: '<span class="favourite-ai__slider-arrow favourite-ai__slider-arrow--prev"><svg class="svg-icon"><use xlink:href="#slider-prev"></use></svg></span>',
          nextArrow: '<span class="favourite-ai__slider-arrow favourite-ai__slider-arrow--next"><svg class="svg-icon"><use xlink:href="#slider-next"></use></svg></span>',
          infinite: true,
          speed: 500,
          cssEase: 'ease-in-out',
          centerPadding: '20px',
          draggable: true,
          // rows: 0,
          variableWidth: true,
          // centerMode: true,
          responsive: [
            {
              breakpoint: 640,
              settings: {
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 1024,
              settings: {
                centerMode: true,
                variableWidth: false,
                slidesToShow: 5,
              },
            },
            {
              breakpoint: 1280,
              settings: {
                centerMode: true,
                variableWidth: false,
                slidesToShow: 7,
              },
            },
          ],
        });
      } else if (isPDAuthorsSlider) {
        $(this.element).slick({
          mobileFirst: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          prevArrow: '<span class="pd-authors__slider-arrow pd-authors__slider-arrow--prev"><svg class="svg-icon"><use xlink:href="#slider-prev"></use></svg></span>',
          nextArrow: '<span class="pd-authors__slider-arrow pd-authors__slider-arrow--next"><svg class="svg-icon"><use xlink:href="#slider-next"></use></svg></span>',
          infinite: true,
          speed: 500,
          cssEase: 'ease-in-out',
          centerPadding: '20px',
          draggable: true,
          // rows: 0,
          variableWidth: true,
          // centerMode: true,
          responsive: [
            {
              breakpoint: 640,
              settings: {
                slidesToShow: 2,
                variableWidth: false,
              },
            },
          ],
        });
      } else {
        // default
        $(this.element).slick({
          mobileFirst: true,
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          prevArrow: '<span class="product-list-slider__arrow product-list-slider__arrow--prev"><svg class="svg-icon"><use xlink:href="#slider-prev"></use></svg></span>',
          nextArrow: '<span class="product-list-slider__arrow product-list-slider__arrow--next"><svg class="svg-icon"><use xlink:href="#slider-next"></use></svg></span>',
          infinite: true,
          speed: 500,
          cssEase: 'ease-in-out',
          centerPadding: '10px',
          draggable: true,
          // rows: 0,
          variableWidth: false,
          // centerMode: true,
          responsive: [
            {
              breakpoint: 640,
              settings: {
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 4,
              },
            },
            {
              breakpoint: 1280,
              settings: {
                slidesToShow: 5,
                dots: false,
              },
            },
          ],
        });
      }
      $('.tiles-hp__item--initializing').removeClass('tiles-hp__item--initializing');
    }, 200);

    $(window).resize(() => {
      $(this.element).slick('resize');
    });

    $('[data-slick-reinit]').on('click', function() {
      let tData = $(this).data('slickReinit');
      $(tData).slick('unslick');
      $(tData).find('.slick-slide').remove();
      $(tData).slick(topProductsSettings);
    });
}
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/ProductListSlider.js